import React, { useEffect, useRef, useState } from "react";
import { SketchPicker } from "react-color";
import FieldHeader from "../FieldHeader";

function ColorInput({ parameters, value, onChange }) {
  const [color, setColor] = useState(value);
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pickerRef]);

  useEffect(() => {
    setColor(value);
  }, [value]);

  return (
    <div>
      <FieldHeader
        label={parameters.label}
        description={parameters.description}
      />
      <div
        style={{
          width: "50px",
          height: "30px",
          backgroundColor: color,
          cursor: "pointer",
          display: "block",
          borderRadius: "5px",
          border: "1px solid #ccc",
        }}
        onClick={() => setShowPicker(true)}
      ></div>
      {showPicker ? (
        <div ref={pickerRef}>
          <SketchPicker
            color={color}
            onChange={(color) => {
              onChange(
                "rgba(" +
                  color.rgb.r +
                  "," +
                  color.rgb.g +
                  "," +
                  color.rgb.b +
                  "," +
                  color.rgb.a +
                  ")"
              );
            }}
            onChangeComplete={(color) => {
              onChange(
                "rgba(" +
                  color.rgb.r +
                  "," +
                  color.rgb.g +
                  "," +
                  color.rgb.b +
                  "," +
                  color.rgb.a +
                  ")"
              );
            }}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default ColorInput;
